<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title></title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet" crossorigin="anonymous">
    <link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet'>
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css">
</head>

<body>
    <div class="main-section container-fluid">
        <div class="centered-content">
            <!-- Logo Section -->
            <div class="logo-section">
                <img src="/assets/img/Bidaya-long.png" alt="Bidaya Home Finance" class="main-logo">
            </div>

            <!-- Router Outlet for Login/Other Components -->
            <router-outlet></router-outlet>
        </div>
    </div>
</body>

</html>
